import Model, { attr } from '@ember-data/model';

export default class MailchimpSyncGroupEmailModel extends Model {
  // properties to send
  @attr('string') groupName!: string;
  @attr('boolean') syncFirstEmails?: boolean;
  @attr('boolean') syncAllEmails?: boolean;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'mailchimp-sync-group-emails': MailchimpSyncGroupEmailModel;
  }
}
